<template>
  <b-modal
    id="cancel-modal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="$emit('cancel-modal')"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        Cancel Meeting
      </div>

      <div @click="$bvModal.hide('cancel-modal')" class="xMarkCancel">
        <img src="../../../assets/xmark.svg" alt="" />
      </div>
      <hr />
      <div class="mt-3 testconfig-card-name">
        <span>Are you sure you want to cancel this meeting?</span>
      </div>
      <div class="model-subhead-kanban">
        <span class="asterik">*</span>
        <span>Please note this action cannot be undone</span>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button
          @click="$bvModal.hide('cancel-modal')"
          class="jdcancelbtn mr-2"
        >
          <img src="../../../assets/reject.svg" alt="" class="mr-2" />
          <span class="rejectfont">No</span>
        </b-button>
        <b-button @click="cancelMeet" class="addbtn pl-3 pr-3">Yes</b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
export default {
  name: "CancelMeeting",
  data() {
    return {
      showSpinner: false,
    };
  },
  methods: {
    cancelMeet() {
      this.showSpinner = true;
      this.$emit("cancel-meet");
      this.showSpinner = false;
    },
  },
};
</script>
